import React from 'react';
import NavbarLanding from '../components/NavbarLanding';
import Footer from './Footer';

const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <NavbarLanding />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-2 text-center">
            Disclaimer
          </h1>
          <p className="text-sm text-gray-500 mb-8 text-center">Last Updated: [Insert Date]</p>
          
          <div className="prose prose-lg max-w-none">
            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. General Information</h2>
                <p className="text-gray-700">
                  The information provided on [Your Website/Company Name] (“we,” “our,” or “us”) is for general informational purposes only. While we strive to keep the information accurate and up to date, we make no warranties or representations of any kind, express or implied, about the completeness, reliability, accuracy, suitability, or availability of the information.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. No Professional Advice</h2>
                <p className="text-gray-700">
                  Content on this website should not be considered professional, legal, financial, or medical advice. You should seek independent professional advice before making decisions based on the information provided.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. External Links</h2>
                <p className="text-gray-700">
                  Our website may contain links to external websites. We are not responsible for the content, availability, or accuracy of these external sites, nor do we endorse the views expressed within them.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Limitation of Liability</h2>
                <p className="text-gray-700">
                  We will not be liable for any loss or damage, including indirect or consequential loss, arising from the use of this website, reliance on its content, or inability to access it.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. User Responsibility</h2>
                <p className="text-gray-700">
                  By using this website, you acknowledge that you are responsible for how you use the information provided and that you do so at your own risk.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Changes to This Disclaimer</h2>
                <p className="text-gray-700">
                  We may update this Disclaimer at any time. Changes will be posted on this page with a new “Last Updated” date.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Disclaimer;


